import React, { useEffect } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import policyHero from '../assets/policy-hero.jpg';

const PrivacyPolicyPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (    <div>
      <Navbar />
   <div style={{
        backgroundImage: `url(${policyHero})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        marginTop: '80px',
        padding: '120px 20px',
        textAlign: 'center',
        color: 'white',
        position: 'relative'
      }}>
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.55)' }}></div>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h1 style={{ fontSize: '48px', fontWeight: '700', marginBottom: '16px' }}>Privacy Policy</h1>
          <p style={{ fontSize: '18px' }}>Your privacy is important to us. Learn how we collect, use, and protect your information.</p>
          <p style={{ marginTop: '12px' }}>Home &bull; Privacy Policy</p>
        </div>
      </div>
      {/* Privacy Policy Content */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="bg-light rounded p-5">
                <div className="mb-4">
                  <p className="text-muted mb-2">Last updated: {new Date().toLocaleDateString()}</p>
                  <p className="lead">
                    At Tecnvirons AI Intelligence Solutions, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our AI solutions and services.
                  </p>
                </div>

                {/* Section 1 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">1. Information We Collect</h3>
                  <p className="mb-3">
                    We collect information you provide directly to us, such as when you:
                  </p>
                  <ul className="mb-3">
                    <li>Create an account or use our services</li>
                    <li>Contact us through our website or support channels</li>
                    <li>Subscribe to our newsletters or marketing communications</li>
                    <li>Participate in surveys, contests, or promotional activities</li>
                  </ul>
                  <p>
                    This may include your name, email address, phone number, company information, and any other information you choose to provide.
                  </p>
                </div>

                {/* Section 2 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">2. How We Use Your Information</h3>
                  <p className="mb-3">We use the information we collect to:</p>
                  <ul>
                    <li>Provide, maintain, and improve our AI solutions and services</li>
                    <li>Process transactions and send related information</li>
                    <li>Send technical notices, updates, security alerts, and support messages</li>
                    <li>Respond to your comments, questions, and customer service requests</li>
                    <li>Communicate with you about products, services, offers, and events</li>
                    <li>Monitor and analyze trends, usage, and activities in connection with our services</li>
                  </ul>
                </div>

                {/* Section 3 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">3. Information Sharing and Disclosure</h3>
                  <p className="mb-3">
                    We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy:
                  </p>
                  <ul>
                    <li><strong>Service Providers:</strong> We may share information with third-party vendors who perform services on our behalf</li>
                    <li><strong>Legal Requirements:</strong> We may disclose information if required by law or to protect our rights</li>
                    <li><strong>Business Transfers:</strong> Information may be transferred in connection with a merger, acquisition, or sale of assets</li>
                    <li><strong>Data Security:</strong> Tecnvirons Marshal do not share or sell customers' mobile phone numbers or <u>SMS opt-in</u> consent data with third parties for marketing or promotional activities</li>
                  </ul>
                </div>

                {/* Section 4 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">4. Data Security</h3>
                  <p>
                    We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.
                  </p>
                </div>

                {/* Section 5 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">5. Your Rights and Choices</h3>
                  <p className="mb-3">You have the right to:</p>
                  <ul className="mb-3">
                    <li>Access, update, delete your personal information</li>
                    <li>Opt-out of marketing communications</li>
                    <li>Request a copy of your data</li>
                    <li>Object to processing of your personal information</li>
                  </ul>
                  <p>
                    To exercise these rights, please contact us at <a href="mailto:ai@tecnvi-ai.com" className="text-primary">ai@tecnvi-ai.com</a>
                  </p>
                </div>

                {/* Section 6 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">6. Cookies and Tracking Technologies</h3>
                  <p>
                    We use cookies and similar tracking technologies to collect and use personal information about you. For more information about our use of cookies, please see our <a href="/tecnvirons-website/cookie-policy" className="text-primary">Cookie Policy</a>.
                  </p>
                </div>

                {/* Section 7 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">7. International Data Transfers</h3>
                  <p>
                    Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place to protect your personal information.
                  </p>
                </div>

                {/* Section 8 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">8. Changes to This Policy</h3>
                  <p>
                    We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
                  </p>
                </div>

                {/* Section 9 */}
                <div className="mb-5">
                  <h3 className="text-primary mb-3">9. Contact Us</h3>
                  <p className="mb-3">If you have any questions about this Privacy Policy, please contact us:</p>
                  <div className="mb-3">
                    <p><strong>Email:</strong> <a href="mailto:ai@tecnvi-ai.com" className="text-primary">ai@tecnvi-ai.com</a></p>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <p><strong>USA:</strong><br />
                      <a href="tel:+13092269909" className="text-primary">+1 (309) 226-9909</a></p>
                      <p><strong>India:</strong><br />
                      <a href="tel:+919371159100" className="text-primary">+91 9371159100</a></p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>USA Headquarters</strong><br />
                      Tecnvirons LLC,
                      2501 Chatham Rd, Suite R<br />
                      Springfield, Illinois 62704</p>
                      <p><strong>India Office</strong><br />
                      <strong>Address 1:</strong><br />
                      Tecnvirons Pvt Ltd
                      F-4, Angel Apartment<br />
                      Road 6, Kalyani Nagar,
                      Pune 411006</p>
                    </div>
                  </div>
                </div>

                {/* Back to Top */}
                <div className="text-center">
                  <a href="#top" className="btn btn-primary py-2 px-4">
                    <i className="fa fa-arrow-up me-2"></i>Back to Top
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
